const settings = {};
const APIDOMAIN = '';

settings.endPoints = {
  publicAuth: APIDOMAIN + "/api/v1/public-auth",
  getSettings: APIDOMAIN + "/api/v1/get-settings",
  getAllProducts: APIDOMAIN + "/api/v1/get-category-products",
  getProduct: APIDOMAIN + "/api/v1/get-product",
  createOrder: APIDOMAIN + "/api/v1/order-place",
  searhProduct: APIDOMAIN + "/api/v1/search-products",
  countryList: APIDOMAIN + "/api/v1/country",
  cityList: APIDOMAIN + "/api/v1/city",
  userLogin: APIDOMAIN + "/api/v1/customer/public-login",
  userLogout: APIDOMAIN + "/api/v1/customer/public-logout",
  userRegister: APIDOMAIN + "/api/v1/customer/register",
  userProfile: APIDOMAIN + "/api/v1/customer/profile",
  userProfileEdit: APIDOMAIN + "/api/v1/customer/edit",
  userTokenRefresh: APIDOMAIN + "/api/v1/customer/public-refresh",
  userChangePassword: APIDOMAIN + "/api/v1/customer/change-password",
  userForgotPassword: APIDOMAIN + "/api/v1/customer/forgot-password",
  userResetPassword: APIDOMAIN + "/api/v1/customer/reset-password",
  userChangeProfilePicture:
    APIDOMAIN + "/api/v1/customer/change-profile-picture",
  userOrderHistory: APIDOMAIN + "/api/v1/customer/order-history",
  shippingPrimaryPrice: APIDOMAIN + "/api/v1/shipping/calculate-primary-price",
  shippingSecondaryPrice:
    APIDOMAIN + "/api/v1/shipping/calculate-secondry-price",
  proceedToPayment: APIDOMAIN + "/api/v1/proceed-to-payment",
  getUndeliverableProducts: APIDOMAIN + "/api/v1/offer/cart-rule-is-deliver",
  getNondeliverableProducts:
    APIDOMAIN + "/api/v1/offer/cart-rule-non-deliverable",
  getOpeningHours: APIDOMAIN + "/api/v1/get-opening-hours",
  groupMinCartTotal: APIDOMAIN + "/api/v1/customer/cart-rule-in-custom-group",
  renderCartButton: APIDOMAIN + "/api/v1/render-cart-button",
  cartTotalshippingFree: APIDOMAIN + "/api/v1/offer/cart-rule-is-shipping-free",
  validateCart: APIDOMAIN + "/api/v1/validate-cart",
  loyaltyPoints: APIDOMAIN + "/api/v1/order/calculate-points",
  getLoyaltyPoints: APIDOMAIN + "/api/v1/customer/get-points",
  getCartOffers: APIDOMAIN + "/api/v1/offer/cart-rule-cart-offer",
  getLanguage: APIDOMAIN + "/api/v1/get-customer-language",
  additionalCharges: APIDOMAIN + "/api/v1/get-additional-charges",
  getCategories: APIDOMAIN + "/api/v1/get-categories",
  getSubCategories: APIDOMAIN + "/api/v1/get-sub-categories",
  getFilters: APIDOMAIN + "/api/v1/get-filters",
  validateDiscountCode: APIDOMAIN + "/api/v1/offer/validate-discount-code",
  paymentMethods: APIDOMAIN + "/api/v1/get-payment-methods",
  getSpecificProducts: APIDOMAIN + "/api/v1/get-specific-products",
  getBestSellingProducts: APIDOMAIN + "/api/v1/get-best-selling-products",
  getOfferProducts: APIDOMAIN + "/api/v1/get-offer-products",
  getAddresses: APIDOMAIN + "/api/v1/customer/get-addresses",
  getAddress: APIDOMAIN + "/api/v1/customer/get-address",
  addAddress: APIDOMAIN + "/api/v1/customer/add-address",
  editAddress: APIDOMAIN + "/api/v1/customer/edit-address",
  deleteAddress: APIDOMAIN + "/api/v1/customer/delete-address",
  setDefaultAddress: APIDOMAIN + "/api/v1/customer/set-default-address",
  getFacertDataUrl: APIDOMAIN + "/api/v1/get-facert",
  getFilterProductUrl: APIDOMAIN + "/api/v1/get-filter-products",
  GetQuantityBasePriceModule: APIDOMAIN + "/api/v1/get-product-price-modules",
  abandonedCart: APIDOMAIN + "/api/v1/get-abandoned-cart",
  storeCart: APIDOMAIN + "/api/v1/store-cart",
  getCategory: APIDOMAIN + "/api/v1/get-category",
  getCategoryByCode: APIDOMAIN + "/api/v1/category/get-categories-by-code",
  getCategoryByProduct: APIDOMAIN + "/api/v1/get-assign-category",
  getTemplateList: APIDOMAIN + "/api/v1/get-template",
  getSocialProviders: APIDOMAIN + "/api/v1/get-social-providers",
  getCmsPageContent : APIDOMAIN +"/api/v1/customer-cms-page/get-page-content-by-url",
  verifyOtp: APIDOMAIN +"/api/v1/customer/verify-customer-otp",
};

export default settings;